module.exports = __webpack_public_path__ + "img/gate_of_kahmunrah_with_tablet.f54db799.jpg";